import PropTypes from 'prop-types';
import { noop } from 'src/utils/core/event';

/* PropTypes */

export const CapContactsPopupComponentPropTypes = {
  isSubmitting: PropTypes.bool,
  jobId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  companyContacts: PropTypes.arrayOf(PropTypes.object),
  setIsSubmitting: PropTypes.func,
};

/* DefaultProps */

export const CapContactsPopupComponentDefaultProps = {
  companyContacts: [],
  isSubmitting: false,
  setIsSubmitting: noop
};
